<template>
  <div class="app-container">
    <div class="form-shell" v-loading="loadingFlag">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="132px">

        <el-form-item prop="guidance" label="新手指南">
          <Tinymce style="width:100%;" :height="500" v-model="form.beginnerGuide" ref="tinymce" />
        </el-form-item>

        <el-form-item prop="withdrawal_instructions" label="体验指南">
          <Tinymce style="width:100%;" :height="500" v-model="form.experienceGuide" ref="tinymce" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { getSet, modifySet } from '@/api/common.js'

export default {
  data: () => ({
    rules: {
      beginnerGuide: [{ required: true, message: '请输入新手指南', trigger: 'change' }],
      experienceGuide: [{ required: true, message: '请输入体验指南', trigger: 'change' }],
    },
    form: {
      beginnerGuide: '',
      experienceGuide: '',
    },
    loadingFlag: false
  }),
  components: { Tinymce },
  beforeMount() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loadingFlag = true

        const { data } = await getSet({
          prefix: "text.fingerpost",
          system_logs_content: "基础管理-指南管理-查看",
          limit: 9999
        })

        this.form.beginnerGuide = data.data.find(item => item.key === "text.fingerpost.novice").value
        this.form.experienceGuide = data.data.find(item => item.key === "text.fingerpost.explain").value

        this.loadingFlag = false
      } catch (err) {
        // this.loadingFlag=false
        console.log('获取失败', err)
      }
    },
    submit() {
      this.$refs["form"].validate(async (flag) => {
        if (flag) {
          try {
            this.loadingFlag = true
            await modifySet({
              "text.fingerpost.novice": {
                value: this.form.beginnerGuide
              },
              "text.fingerpost.explain": {
                value: this.form.experienceGuide
              },
            })
            this.$message({
              message: "修改成功",
              type: "success"
            })
            this.getData()
          } catch (err) {
            this.loadingFlag = false
            console.log(err)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-shell {
  max-width: 880px;
}
</style>